<button
  payee-icon-button
  class="actions-menu-button"
  color="white"
  data-testid="cases-actions-menu"
  [matMenuTriggerFor]="actionsMenu"
  (menuOpened)="onActionsMenuOpen()"
  (menuClosed)="onActionsMenuClosed()"
>
  <payee-icon
    name="more-blue"
    width="20px"
    height="20px"
  ></payee-icon>
</button>

<mat-menu
  #actionsMenu
  xPosition="before"
  class="actions-menu"
>
  <div
    class="actions-menu-header"
    (click)="$event.stopPropagation()"
  >
    <strong class="actions-menu-title">
      {{ "CASES_TABLE.ACTION_GROUPS.CASE_ACTIONS" | translate }}
    </strong>
    <div
      class="case-id-box"
      (click)="copyCaseIdToClipboard($event)"
    >
      <span class="case-id-text">
        {{ element.payee_case_reference_id }}
      </span>
      <payee-icon
        name="copy-blue"
        width="14px"
        height="14px"
        class="case-id-icon"
      ></payee-icon>
    </div>
    @if (shouldShowActionFilter()) {
      <payee-form-field
        width="max"
        class="actions-filter"
      >
        <input
          #actionFilterInput
          payee-input
          [placeholder]="'CASES_TABLE.CASE_ACTIONS.SEARCH_PLACEHOLDER' | translate"
          [ngModel]="actionFilter()"
          (ngModelChange)="actionFilter.set($event)"
          (click)="$event.stopPropagation()"
        />
      </payee-form-field>
    }
  </div>

  @for (group of element.actions; track group.id) {
    @if (showGroup(group)) {
      <section class="action-group">
        <div class="action-group-label">
          <strong class="actions-menu-section-title">
            {{ group.label }}
          </strong>
        </div>

        @if (group.id === "operation") {
          @if (showEditAction()) {
            <button
              mat-menu-item
              (click)="editCase()"
            >
              <span class="actions-menu-item-inner">
                <payee-icon
                  class="actions-menu-item-icon"
                  width="16px"
                  height="16px"
                  name="pencil"
                ></payee-icon>
                <span>{{ "CASES_TABLE.CASE_ACTIONS.EDIT" | translate }}</span>
              </span>
            </button>
          }

          @if (showPayFeeAction()) {
            <button
              mat-menu-item
              data-testid="pay-start-fee-action"
              (click)="openPayFeeDialog()"
            >
              <span class="actions-menu-item-inner">
                <payee-icon
                  class="actions-menu-item-icon"
                  width="16px"
                  height="16px"
                  name="qvik-blue"
                ></payee-icon>
                <span>{{ "CASES_TABLE.START_PAYMENT_CHOICE.TITLE" | translate }}</span>
              </span>
            </button>
          }

          @for (action of additionalActions; track $index) {
            @if (action.show(element) && showAction(action.label | async)) {
              <button
                mat-menu-item
                (click)="action.onClick(element)"
              >
                <span class="actions-menu-item-inner">
                  <payee-icon
                    class="actions-menu-item-icon"
                    width="16px"
                    height="16px"
                    [name]="action.icon || 'document'"
                  ></payee-icon>
                  <span>{{ action.label | async }}</span>
                </span>
              </button>
            }
          }

          @if (showDownloadDocumentsAction()) {
            <button
              mat-menu-item
              (click)="openDownloadDocumentsDialog()"
            >
              <span class="actions-menu-item-inner">
                <mat-icon
                  class="actions-menu-item-icon"
                  width="16px"
                  height="16px"
                >
                  download
                </mat-icon>
                <span>
                  {{ "CASES_TABLE.CASE_ACTIONS.DOWNLOAD_DOCUMENTS" | translate }}
                </span>
              </span>
            </button>
          }
        }

        @for (event of getRegularGroupItems(group); track event.id) {
          @if (showAction(event.label)) {
            <button
              mat-menu-item
              class="action-button"
              (click)="openTransitionDialog(event)"
            >
              <span class="actions-menu-item-inner">
                @if (event.icon) {
                  <payee-icon
                    class="actions-menu-item-icon"
                    width="16px"
                    height="16px"
                    [name]="event.icon"
                  ></payee-icon>
                }
                <span>{{ event.label }}</span>
              </span>
            </button>
          }
        }

        @if (group.id === "operation") {
          @if (showBailiffContactAction()) {
            <a
              mat-menu-item
              class="bailiff-contact-action"
              rel="noopener noreferrer"
              target="_blank"
              [href]="element.bailiff_contact_url!"
            >
              <span class="actions-menu-item-inner">
                <payee-icon
                  class="actions-menu-item-icon"
                  width="16px"
                  height="16px"
                  name="external-link-blue"
                ></payee-icon>
                <span>
                  {{ "CASES_TABLE.CASE_ACTIONS.BAILIFF_CONTACT" | translate }}
                </span>
              </span>
            </a>
          }
        }

        @for (event of getCloseGroupItems(group); track event.id) {
          @if (showAction(event.label)) {
            <button
              mat-menu-item
              class="action-button is-close"
              (click)="openTransitionDialog(event)"
            >
              <span class="actions-menu-item-inner">
                @if (event.icon) {
                  <payee-icon
                    class="actions-menu-item-icon"
                    width="16px"
                    height="16px"
                    [name]="event.icon"
                  ></payee-icon>
                }
                <span>{{ event.label }}</span>
              </span>
            </button>
          }
        }

        @if (group.id === "operation") {
          @if (showDeleteAction()) {
            <button
              mat-menu-item
              class="delete-case-action"
              data-testid="delete-case-action"
              (click)="deleteCase()"
            >
              <span class="actions-menu-item-inner">
                <payee-icon
                  class="actions-menu-item-icon"
                  width="16px"
                  height="16px"
                  name="trash-black"
                ></payee-icon>
                <span>{{ "CASES_TABLE.CASE_ACTIONS.DELETE" | translate }}</span>
              </span>
            </button>
          }
        }
      </section>
    }
  }
</mat-menu>
